import React from 'react';
import { Text } from '@mantine/core';
import {
  TABLE_STYLE_PRESETS,
  applyTableStyle,
  storedTableDesign,
} from './tableStyles';
import { useSelectedItemProps } from '../../../puck/fields/useSelectedItemProps';
import ThemeStyleGallery from '../../../puck/fields/ThemeStyleGallery';
import StyleCardPreview from '../../../theme/StyleCardPreview';
import styles from './TableStylePicker.module.css';

/**
 * Galerie de styles de tableau. Un style est un JEU DE VALEURS, pas une
 * variante.
 * Les génériques sont des COPIES : en cliquer un recopie ses valeurs dans le
 * bloc, qui reste « Personnalisé » (aucun n'est jamais surligné). Seul un
 * style du thème se suit (cf. ThemeStyleGallery).
 *
 * Le champ est déclaré sur `design.useCustomBorder` — la seule prop de style
 * que la sidebar n'édite plus. Puck indexe ses champs par nom de prop : il
 * fallait une clé libre pour héberger le sélecteur, qui écrit de toute façon
 * TOUT `design` par dispatch. Même arrangement que `loop` sur le Carrousel.
 */
export default function TableStylePicker() {
  const { itemProps, updateItemProps } = useSelectedItemProps();
  const design = storedTableDesign(itemProps.design);

  return (
    <ThemeStyleGallery kind="table" classes={styles}>
      <div className={styles.grid} role="listbox" aria-label="Style du tableau">
        {TABLE_STYLE_PRESETS.map((def) => (
          <button
            key={def.key}
            type="button"
            role="option"
            aria-selected={false}
            title={def.label}
            className={styles.card}
            // Un seul dispatch : le style pose tout `design` d'un coup, donc
            // une seule entrée d'historique et un seul patch autosave. Les
            // colonnes et les lignes ne sont pas touchées.
            onClick={() => updateItemProps({ design: applyTableStyle(design, def), themeStyleId: null })}
          >
            <StyleCardPreview kind="table" values={def.props} />
            <Text size="10px" c="dimmed" lh={1.2} ta="center">
              {def.label}
            </Text>
          </button>
        ))}
      </div>
    </ThemeStyleGallery>
  );
}
